import Swal from 'sweetalert2/dist/sweetalert2';

export default (message) => {
    // add '.system' to class
    // for style.css to change confrimButton background color.
    return Swal.mixin({ customClass: { confirmButton: 'system' } }).fire(message);
};